import * as React from 'react';

import type {Truncate} from 'shells/typography/body';

import type {EntitySummaryRating} from 'nutshell-graphql-types';

import {colors} from '../colors/colors';
import {TextRegularAiIcon} from '../icon/svg/text-regular-ai-icon';
import {Stack} from '../layout/stack/stack';
import {Body} from '../typography/body';
import {SectionLabel} from '../typography/section-label';

import {Footer} from './footer';

import styles from './summary.module.css';

type Props = {
    title?: string;
    summary: string;
    userRating?: EntitySummaryRating | null | undefined;
    isSavingRating?: boolean;
    truncate?: Truncate;
    onRate?: (rating: EntitySummaryRating) => Promise<any>;
};

export function Summary(props: Props) {
    return (
        <div className={styles.container}>
            {props.title && (
                // @ts-expect-error
                <Stack isHorizontal={true} spacing={4} alignCenter={true}>
                    <TextRegularAiIcon
                        // @ts-expect-error
                        color={colors.aiPurplePrimary}
                        fill={colors.aiPurplePrimary}
                        size={20}
                        alignCenter={true}
                    />
                    <SectionLabel color='ai-purple' noBottomBorder={true}>
                        {props.title}
                    </SectionLabel>
                </Stack>
            )}
            <Stack spacing={8}>
                <Body size='small' color='dark' maintainLineBreaks={true} truncate={props.truncate}>
                    {props.summary}
                </Body>
                <Footer
                    userRating={props.userRating}
                    onRate={props.onRate}
                    isSavingRating={props.isSavingRating}
                />
            </Stack>
        </div>
    );
}
